/**
 * @module ProductQuickView
 */

import Component from '../base/Component';
import './styles.css';
import '../../styles/preloader.css';
import '../base/Radio';
import { initChangeVariantsHandler } from '../../scripts/backend/common-catalog';
import Spinner from '../base/Spinner';

/**
 * Раздел UI Kit.
 */
export default class ProductQuickView extends Component {
    static className = 'product-quick-view';

    initElements() {
        this.elements = {
            $spinner: $('.spinner', this.$block),
        };
    }

    init(options) {
        super.init(options);

        this.setSpinner();
        this.setChangeHandler();
    }

    setSpinner() {
        const spinner = new Spinner(this.elements.$spinner);

        spinner.init();
    }

    setChangeHandler() {
        initChangeVariantsHandler(this.$block);
    }
}
